import moment from 'moment';
import {
  size, maxBy, cloneDeep, has, includes,
} from 'lodash';

import APIClient from '../../../../common/services/APIClient';
import { makeDemoEventGenerator } from '../Demo';
import { detectDemoMode } from '../Demo/helper';
import {
  EVENT_TYPE_END_CHARGING_SESSION,
  EVENT_TYPE_START_CHARGING_SESSION,
  EVENT_TYPE_START_DISCHARGING_SESSION,
  mapEventTypes,
} from './helper';

const eventGenerator = makeDemoEventGenerator();

const demoSessions = {};

export const initLogsBase = (logsArray, createdAt) => ({
  type: 'INIT_LOGS_BASE',
  logsArray,
  createdAt,
});

export const clearState = () => ({
  type: 'CLEAR_LOGS_STATE',
});

export const initNewLogs = (logsArray, createdAt) => ({
  type: 'INIT_NEW_LOGS',
  logsArray,
  createdAt,
});

export const sliceFirstChargerEvent = (chargerUuid) => ({
  type: 'SLICE_FIRST_CHARGER_EVENT',
  payload: chargerUuid,
});

export const sortDescByKey = (array, key) => array.sort((a, b) => {
  const x = a[key];
  const y = b[key];

  return ((x < y) ? 1 : ((x > y) ? -1 : 0));
});

const clearNewLogs = () => ({
  type: 'CLEAR_NEW_LOGS',
});

export const setInitialValues = (values) => ({
  type: 'SET_INITIAL_VALUES',
  payload: values,
});

export const setIsSubmitted = (value) => ({
  type: 'SET_IS_SUBMITTED',
  payload: value,
});

export const clearLogs = () => ({
  type: 'CLEAR_LOGS',
});

export const loadLogs = (params = {}) => (dispatch) => {
  const {
    plazaId,
    eventTimeFrom,
    eventTimeTo,
    createdTimeFrom,
    createdTimeTo,
    chargerUuids = [],
    eventTypes = [],
  } = params;

  if (!plazaId || !eventTimeFrom || !eventTimeTo) {
    return;
  }
  const filterBy = {
    createdTimeFrom,
    createdTimeTo,
    // *1000 is important since BE for some reasons uses macro seconds
    eventTimeFrom: (eventTimeFrom * 1000).toString(),
    eventTimeTo: (eventTimeTo * 1000).toString(),
    chargerUuids: chargerUuids.map((item) => item.value),
    eventTypes: eventTypes.map(mapEventTypes),
  };

  if (detectDemoMode()) {
    const newEvents = eventGenerator.next().value;

    if (eventTimeFrom) {
      const currentUnix = moment().utc().valueOf();
      const modifiedEvents = cloneDeep(newEvents).map((event, i) => {
        event.uuid = `${event.uuid}_${currentUnix}`;
        event.plazaUuid = `${event.plazaUuid}_${currentUnix}`;
        event.ts = currentUnix + i;

        if (includes([EVENT_TYPE_START_CHARGING_SESSION, EVENT_TYPE_START_DISCHARGING_SESSION], event.plazaEventType)) {
          event.values.start_time = Math.round(event.ts / 1000);
          demoSessions[event.chargerUuid] = event.values.start_time;
        }

        if (event.plazaEventType === EVENT_TYPE_END_CHARGING_SESSION && has(demoSessions, event.chargerUuid)) {
          event.values.end_time = Math.round(event.ts / 1000);
          event.values.start_time = demoSessions[event.chargerUuid];
          event.values.departure_time = event.values.end_time + 50;
          delete demoSessions[event.chargerUuid];
        }

        return event;
      });

      dispatch(initNewLogs(modifiedEvents, currentUnix));
    }

    return false;
  }

  return APIClient
    .post(`/plazas/${plazaId}/events`, { filterBy }, {
      params: { page: -1, sortBy: 'createdTime', sortingOrder: 'DESC' },
    })
    .then(({ data }) => {
      if (size(data.payloads)) {
        const lastEvent = maxBy(data.payloads, 'createdAt');
        const sortedData = sortDescByKey(data.payloads, 'ts').map((item) => ({
          ...item,
          ts: Math.floor(item.ts / 1000),
        }));

        if (!createdTimeTo) {
          dispatch(initLogsBase(sortedData, lastEvent.createdAt));
        } else {
          dispatch(initNewLogs(sortedData, lastEvent.createdAt));
        }
      } else {
        dispatch(clearNewLogs());
      }
    })
    .catch(console.error);
};
